import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getDevices(Subscription:number) {
  return axios.get(API_URL+'/v1/ctxr/'+Subscription+'/list')
}
export function getDevicesListglobal(Subscription:number,tenant:number) {
  return axios.get(API_URL+'/v1/ctxr/'+Subscription+'/list?tenantId='+tenant)
}
export function getpermisosDisponibles() {
  return axios.get(API_URL+'/v1/permission')
}
export function getpermisosDisponiblesGlobal(tenant:number) {
  return axios.get(API_URL+'/v1/permission?tenantId='+tenant)
}
export function getNeigborId(uuid:any,id:any) {
    return axios.get(API_URL+'/v1/ctxr/configbgpneighbor/'+uuid+'/'+id)
  }
export function getNeigborIdGlobal(uuid:any,id:any,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/configbgpneighbor/'+uuid+'/'+id+'?tenantId='+tenant)
  }
export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }

export function getips(uuid:any) {
    return axios.get(API_URL+'/v1/ctxr/listcni/'+uuid)
  }
export function getipstenant(uuid:any,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/listcni/'+uuid+'?tenantId='+tenant)
  }